import React from "react";
import { Icon, MenuItem } from "@chakra-ui/react";
import { IoCloseOutline } from "react-icons/io5";
import { SelectionContext } from "../../../../../../duck";

const CancelSelection: React.FC = () => {
  const { setSelected } = React.useContext(SelectionContext);

  return (
    <MenuItem
      py={2.5}
      lineHeight={5}
      color="gray.900"
      fontSize="sm"
      icon={<Icon as={IoCloseOutline} boxSize="16px" display="block" />}
      onClick={() => setSelected([])}
    >
      Cancel selection
    </MenuItem>
  );
};

export default CancelSelection;
